interface FieldPropertiesInput {
  disabled?: boolean
  isLoading?: boolean
  error?: string | null
  dataTestId: string
}

interface FieldProperties {
  disabled: boolean
  error: boolean
  helperText?: string
}

export function getFieldProperties(
  { disabled = false, isLoading = false, error, dataTestId }: FieldPropertiesInput,
  fieldType: 'from' | 'to'
): FieldProperties & { dataTestId: string } {
  return {
    disabled: disabled || isLoading,
    error: !!error,
    helperText: error ? 'Failed to load pay periods' : undefined,
    dataTestId: `${dataTestId}-${fieldType}-field`
  }
}

export function getGridColumns(arrange: 'Horizontal' | 'Stack'): number {
  return arrange === 'Stack' ? 12 : 6
}